/**
 * Whether a feature is switched on in this environment. Switches live in
 * runtimeConfig.public.features (nuxt.config.ts) and are set per environment with
 * NUXT_PUBLIC_FEATURES_<NAME>=true, so staging and production run the same build.
 */
export type Feature = keyof ReturnType<typeof useRuntimeConfig>['public']['features'];

export const useFeature = (feature: Feature): boolean => Boolean(useRuntimeConfig().public.features?.[feature]);
